import setItemState from "./setItemState";
import { ITEM_STATE_TO_BAG_IN_PROGRESS } from "../../constants";

export default (state, { payload: { id } }) => ({
  ...setItemState(state, id, ITEM_STATE_TO_BAG_IN_PROGRESS)
});
